<template>
	<v-container grid-list-md class="container--box">
		<v-layout row wrap>
			<v-flex xs12 class="my-10">
				<h2 class="white--text">
					Please select your delivery address!
				</h2>
			</v-flex>
			<v-flex xs12>
				<v-row>
					<v-col
						v-for="(address, i) in addresses"
						:key="i"
						cols="12"
						md="4"
					>
						<Link
							as="v-card"
							flat
							outlined
							raised
							tile
							:href="
								$route('shop.delivery.tenants', {
									address_uuid: address.uuid,
								})
							"
						>
							<v-card-title primary-title>
								<v-icon left v-if="address.name == 'home'">
									mdi-home</v-icon
								>
								<v-icon left v-else>mdi-map-marker</v-icon>
								{{ address.name }}
								<v-spacer></v-spacer>

								<v-btn
									text
									icon
									small
									color="primary"
									@click="editAddress(address)"
								>
									<v-icon>mdi-pencil</v-icon>
								</v-btn>
								<v-btn
									text
									icon
									small
									color="red"
									@click="deleteAddress(address)"
								>
									<v-icon>mdi-delete</v-icon>
								</v-btn>
							</v-card-title>
							<v-card-text>
								{{ address.house_number }},
								{{ address.street }}
								<p>
									<v-icon left small>mdi-map-marker</v-icon>
									{{ address.address }}
								</p>
								<p>
									<v-icon left small>mdi-account</v-icon>
									{{ address.contact_person }}
									<br />
									<v-icon left small>mdi-cellphone</v-icon>
									{{ address.phone_number }}
								</p>
							</v-card-text>
						</Link>
					</v-col>
				</v-row>
			</v-flex>
		</v-layout>

		<v-dialog :value="$wait.is('opening address form')" persistent>
			<ValidationObserver ref="obs" v-slot="{ invalid }">
				<v-card>
					<v-card-title primary-title>
						{{ $t("title.address_form") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<ShopFormAddress v-model="address"></ShopFormAddress>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							text
							@click="$wait.end('opening address form')"
							>{{ $t("Close") }}</v-btn
						>
						<v-btn
							color="primary"
							@click.native="submitAddress()"
							:loading="address.processing"
							:disabled="invalid"
						>
							<v-icon left>mdi-content-save</v-icon>
							{{ $t("Save") }}
						</v-btn>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</ValidationObserver>
		</v-dialog>
	</v-container>
</template>

<script>
import ShopFormAddress from "@Shop/forms/ShopFormAddress.vue";
import { Link } from "@inertiajs/inertia-vue";
export default {
	props: ["addresses"],
	components: {
		ShopFormAddress,
		Link,
	},

	data() {
		return {
			address: this.$inertia.form({}),
			dialog: false,
		};
	},

	methods: {
		addAddress() {
			this.address = this.$inertia.form({
				name: "home",
				house_number: null,
				street: null,
				address: null,
				phone_number: this.$page.props.auth.customer.phone,
				contact_person: this.$page.props.auth.customer.display_name,
				description: null,
				latitude: 11.562454466918203,
				longitude: 104.92219185180667,
			});
			this.$wait.start("opening address form");
		},

		editAddress(address) {
			this.address = this.$inertia.form(address);
			this.$wait.start("opening address form");
		},

		submitAddress() {
			if (this.address.uuid) {
				this.address.put(
					this.$route("shop.addresses.update", {
						address: this.address.uuid,
						response: "json",
					}),
					{
						onSuccess: () => this.$wait.end("opening address form"),
						preserveScroll: true,
						preserveState: true,
					}
				);
			} else {
				this.address.post(
					this.$route("shop.addresses.store", {
						response: "json",
					}),
					{
						onSuccess: () => this.$wait.end("opening address form"),
						preserveScroll: true,
						preserveState: true,
					}
				);
			}
		},
	},
};
</script>